export type ExperimentType = {
  assignedBucket: string;
  experimentName: string;
};

export type Experiments = { [key: string]: string };

const createExperimentList = () => {
  const dict: Experiments = {};

  const addExperiment = (experiment: ExperimentType) => {
    if (!experiment) return;
    if (dict[experiment.experimentName]) return;
    dict[experiment.experimentName] = experiment.assignedBucket;
  };

  const getAllExperiments = () => dict;

  return {
    getAllExperiments,
    addExperiment
  };
};

const experimentHelper = createExperimentList();

export default experimentHelper;